import { Route, Switch } from 'wouter';
import { MainLayout } from './shared/main-layout';
import { Home } from './home';
import { Orders } from './orders';
import { HistoricData } from './historic-data';
import { Issues } from './issues';
import { Settings } from './settings';

function App() {
  return (
    <MainLayout>
      <Switch>
        <Route path="/issues" component={Issues} />
        <Route path="/orders" component={Orders} />
        <Route path="/historic-data" component={HistoricData} />
        <Route path="/settings" component={Settings} />
        <Route path="*" component={Home} />
      </Switch>
    </MainLayout>
  );
}

export default App;
